import { fetch } from '@/common/js/fetch';
import { serverCourseUrl } from "./api";
import {DEFAULT_COMPETITION_TYPE} from "@/common/constant/qz";
import parseParams from '@/common/js/util';

/**
 * @description 试卷列表
 * */
export function searchPaperList(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/exam/list`, {
      competitionType:DEFAULT_COMPETITION_TYPE,
      ...parseParams(params),
    },{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
/**
 * @description 答题详情
 * @param {String} userCourseExamRelationInstanceId 用户答题试卷id
 * */

export function getExamPaperDetail(userCourseExamRelationInstanceId) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/exam/query?userCourseExamRelationInstanceId=${userCourseExamRelationInstanceId}`)
}

/**
 * @description 保存试卷批改状态
 * */
export function saveCheckPaper(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/exam/mark`, {...params}, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

/**
 * @description 上/下 一张
 * */
export function getExamPaperNext(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/exam/next`, {
      competitionType:DEFAULT_COMPETITION_TYPE,
      ...parseParams(params),
    }, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

/**
 * @description 查询所有学校，只会查询到自己有权限的学校列表
 * @param { Array } roles 角色列表 如 ['TEACHER', 'ADMIN']
 * */
export function getUserSchools(rolesList) {
  const roles = (rolesList || []).join(',')
  return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/school/list?competitionType=${DEFAULT_COMPETITION_TYPE}&roles=${roles}`)
}

/**
 * @description 查询用户列表
 * **/
export function getUserList(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/user/list`,{
        competitionType:DEFAULT_COMPETITION_TYPE,
        ...parseParams(params)
    },{
        method: 'POST'
    })
}

/**
 * @description 创建编辑账号
 * */
export function createUser(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/create/user/save`,{
        competitionType:DEFAULT_COMPETITION_TYPE,
        ...parseParams(params),
    },{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

/**
 * @description 批量创建编辑账号
 * */
export function createUserTask(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/create/user/task/save`,{},{
        method: 'POST',
        body: params,
    })
}

/**
 * @description 查询批量生成账号记录
 * */
export function updateUserTask(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/create/user/task/list`,{
        competitionType:DEFAULT_COMPETITION_TYPE,
        ...parseParams(params)
    })
}
/**
 * @description 查询批量生成账号任务详情（用于导出）
 * */
export function exportUserList(taskId) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/create/user/task/detail/query`,{
        taskId
    })
}

/**
 * @description 根据关键词查询考试列表，用于筛选学生考试
 * @param {Object} params
 * @returns
 */
export function getExamRounds(params) {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     "examRounds": [{
  //       "id": 1, // 考试id
  //       "courseExamId": 1, // 试卷id
  //       "competitionType": "",
  //       "level": "",
  //       "roundName": "考试名",
  //       "order": 12, // 权重
  //       "startTime": 1111111, // 开始时间
  //       "releaseResultTime": 1111111, // 释放成绩时间
  //       // 考试关联的学校列表
  //       "schools": [{
  //           "id": 1, // 学校id
  //           "schoolName": "学校名称"
  //       }]
  //   }]
  //   }
  // })
  const { level, roundName } = params
  return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/round/search?roundName=${roundName}&level=${level}&competitionType=${DEFAULT_COMPETITION_TYPE}`);
}

/**
 * 获取用户考试列表
 * @param { Object } params
 * @param { String } params.level 考试等级
 * @param { String } params.markStatus 批改状态 0，1，2
 * @param { String } params.username 用户姓名
 * @param { String } params.schoolId 学校id
 * @param { String } params.roundId 考试id
 * @param { String } params.pageNo 页码
 * @param { String } params.pageSize 每页数量
 * @returns
 */
export function getUserExamRounds(params) {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     "totalCount": 3,
  //     "userExamRounds": [{
  //         id: 191109,
  //         "roundId": 1, // 考试id
  //         "roundName": "哈哈航昂啊哈航昂昂考试名称111", // 考试名称
  //         "title": "试卷名称",
  //         "markMode":'CROSS',
  //         "courseExamId": 1, // 试卷id
  //         "username": "chenqinfei",
  //         "school": {
  //             "id": 11,
  //             "schoolName": "求知小学"
  //         },
  //         "startTime": 1757397733827, // 考试考试时间
  //         "endTime": 1757397733827, // 提交试卷时间
  //         "totalCostTime": 1800, // 耗时, 单位s
  //         "totalPoints": 1000, // 总得分
  //         "markStatus": 2, // 批改状态
  //         "competitionType": "",
  //         "level": "MATHS_TALENTS_1"
  //     }]
  // }
  // })

  return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/user/round/list`, {
    competitionType:DEFAULT_COMPETITION_TYPE,
    ...parseParams(params),
  },{
    method: 'POST',
  })
}
export function getUserExamStatistics(params) {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //   "markStatusStatistics": {
  //     "0": 1,
  //     "1": 2,
  //     "2": 0
  //   }
  //   }
  // });
  return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/user/round/statistics`, {
    competitionType:DEFAULT_COMPETITION_TYPE,
    ...parseParams(params),
  }, {
    method: 'POST',
  })
}

//  交叉批改规则列表
export function getExamMarkRelationList(params) {
    // return Promise.resolve({
    //     code: 200,
    //     body: {
    //         "totalCount": 120,
    //         "rounds": [{
    //             "id": 1,
    //             "roundName": "考试名称", //考试名称
    //             "schools": [{
    //                 "id": 1,
    //                 "schoolName": "清华附中"
    //             }],
    //             "startTime": 1758193200000,
    //             "rule": {
    //                 "id": "RULE_MATHS_TALENTS_4",
    //                 "costTime": 120,
    //                 "totalCount": null,
    //                 "totalPoint": 100,
    //                 "startPoint": 0,
    //                 "description": "考试时间120分钟，总分100分。总共8道题：第1-5题（填空题）每道题8分，第6-8题（解答题）每道题20分，答错/不答不得分",
    //                 "intervals": [
    //                     {
    //                         "start": 1,
    //                         "end": 5,
    //                         "score": "8",
    //                         "errorScore": 0
    //                     },
    //                     {
    //                         "start": 6,
    //                         "end": 8,
    //                         "score": "20",
    //                         "errorScore": 0
    //                     }
    //                 ]
    //             },
    //             "markMode": "CROSS",
    //             "markModeStatus":0, // 0未确认 1已确认
    //             "lastOpUsername": "zzz", //规则确认人
    //             "markId": 112 // 批改id
    //         }]
    //     }
    // })
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/round/mark/mode/list`,{
        competitionType:DEFAULT_COMPETITION_TYPE,
        ...parseParams(params),
    },{
        method: 'POST',
    })
}

/**
 * @description 获取交叉批改规则详情
 * @param { String } id 批改id
 * @param {String} level 考试类型
 * */
export function getMarkRelationDetail(id,level) {
    // return Promise.resolve({
    //     code: 200,
    //     body:{
    //         "roundMark": {
    //             "competitionType": "",
    //             "level": "",
    //             "courseExamId": 1,
    //             "roundId": 1,
    //             "lastOpUser": "",
    //             "status": 1,
    //             "relations": [{
    //                 "id": 1,
    //                 "roundMarkId": 1,
    //                 "courseExamId": 1,
    //                 "roundId": 111,
    //                 "schoolId": 1,
    //                 "schoolName": "待批改学校name",
    //                 "markSchoolId": 2,
    //                 "markSchoolName": "批改学校name"
    //             },{
    //                 "id": 2,
    //                 "roundMarkId": 1,
    //                 "courseExamId": 1,
    //                 "roundId": 111,
    //                 "schoolId": 2,
    //                 "schoolName": "待批改学校name",
    //                 "markSchoolId": 3,
    //                 "markSchoolName": "批改学校name"
    //             }]
    //         }
    //     }
    // })
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/round/mark/query`,{
        id,
        level,
        competitionType:DEFAULT_COMPETITION_TYPE,
    })
}

/**
 * 保存交叉
 * @param { Object } params
 * */
export function saveMarkRelation(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/round/mark/relation/save`,{
        competitionType:DEFAULT_COMPETITION_TYPE,
        ...parseParams(params),
    },{
        method: 'POST',
    })
}

/**
 * @description 确认交叉批改规则
 * @param { Object } params 批改id
 * */
export function publishMarkRelation(params) {
    return fetch(`${serverCourseUrl}v1/user/course/exam/teacher/round/mark/publish`,{
        competitionType:DEFAULT_COMPETITION_TYPE,
        ...parseParams(params),
    })
}

/**
 *  获取考试统计数据
 * @param {*} roundId
 * @param {*} competitionType
 * @returns
 */
export const getStudentInvigilateStat = (roundId, competitionType=DEFAULT_COMPETITION_TYPE) => {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     "roundStatistics": {
  //       "roundId": 1,
  //       "roundName": "考试名称",
  //       "statistics": {
  //           "actualCount": 1212, // 实际参加考试人数
  //           "finishCount": 1200, // 完成考试人数
  //           "normalCount": 1000, // 正常人数
  //           "doubtCount": 231 // 存疑人数
  //       }
  //     }
  //   }
  // })
  return fetch(`${serverCourseUrl}v1/user/round/invigilate/playback/statistics`, {
    roundId,
    competitionType,
  })
}

/**
 * 获取考试学生列表
 * @param {*} params
 * @returns
 */
export const getStudentInvigilateList = (params) => {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     "students": [
  //   {
  //     "id": 123,
  //     "name": "姓名",
  //     "phone": 13600001234,
  //     "room_id": 123,
  //     "examDurationMin": 120, // 花费时间
  //     "cheat": true,
  //     "cheatCounts": { // 各项作弊行为的次数
  //       "CALL": 1,
  //       "HAT": 2
  //     },
  //     "remarks": [
  //       {
  //         // 目前前端只展示备注内容，没有展示操作人、备注时间等字段
  //         "content": "考生没有作弊，保留成绩"
  //       }
  //     ]
  //   },]
  //   }
  // })
  return fetch(`${serverCourseUrl}v1/user/round/invigilate/playback/student/list`, {
    competitionType:DEFAULT_COMPETITION_TYPE,
    ...params,
  })
}

/**
 * 获取考试学生监考详情
 * @param {*} params
 * @param {*} param.competitionType
 * @param {*} param.roomId
 * @param {*} param.userId
 * @param {*} param.startTimeMs
 * @param {*} param.endTimeMs
 * @returns
 */
export const getStudentInvigilateDetail = (params) => {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     "user": {
  //       "name": "姓名",
  //       "phone": 13600001234,
  //       cheat: false,
  //       userId: 123,
  //       "costTimeSec": 7200,
  //     },
  //     "records": {
  //       "cameraPc": [
  //         {
  //           "m3u8": "https://pandapub.nosdn.127.net/tmp1758885085_0fqg4unywdhp6c9bjeuqig%3D%3D_2_1758881485_1.m3u8",
  //           "startTimeSec": 1758854520, // unix 时间戳（秒）。阿里生成录播视频，时间戳只能精确到秒（下同）
  //           "endTimeSec": 1758854550 // unix 时间戳（秒）
  //         },
  //         {
  //           "m3u8": "https://pandapub.nosdn.127.net/tmp1758874564_eoae4mjiowr91jfa9_lcya%3D%3D_2_1758870964_4.mp4",
  //           "startTimeSec": 1758855300, // unix 时间戳（秒）。阿里生成录播视频，时间戳只能精确到秒（下同）
  //           "endTimeSec": 1758855330 // unix 时间戳（秒）
  //         },
  //       ],
  //     },
  //     // 作弊记录
  //   "cheats": [
  //     {
  //       "type": "personExit",
  //       "timeMs": 1758854530000,
  //     },
  //     {
  //       "type": "actionPoseStandup",
  //       "timeMs": 1758855320000,
  //     },
  //   ],
  //   // 备注
  //   "remarks": [
  //     {
  //       "author": { // 操作人
  //         "id": 213,
  //         "name": "老师姓名"
  //       },
  //       "content": "考生没有作弊，保留成绩",
  //       "timeMs": 1758854578000
  //     }
  //   ]
  //   }
  // })
  return fetch(`${serverCourseUrl}v1/user/round/invigilate/playback/student/detail`, {
    competitionType:DEFAULT_COMPETITION_TYPE,
    ...params,
  })
}

/**
 *
 * @param {number} roomId
 * @param {number} userId
 * @param {Object} body
 * @param {string} body.content
 * @returns
 */
export const saveStudentInvigilateRemark = (roomId, userId, body) => {
  return fetch(`${serverCourseUrl}v1/user/round/invigilate/playback/student/remark/put?roomId=${roomId}&userId=${userId}`, body, {
    method: 'POST',
  })
}